import React, { createContext, useState, ReactNode, useContext } from 'react';

interface MatrizFileContextType {
  imageMatriz: File | null;
  setImageMatriz: React.Dispatch<React.SetStateAction<File | null>>;
  pdfMatriz: File | null;
  setPdfMatriz: React.Dispatch<React.SetStateAction<File | null>>;
}

const MatrizFileContext = createContext<MatrizFileContextType | undefined>(
  undefined
);

export const MatrizFileProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [imageMatriz, setImageMatriz] = useState<File | null>(null);
  const [pdfMatriz, setPdfMatriz] = useState<File | null>(null);

  return (
    <MatrizFileContext.Provider
      value={{
        imageMatriz,
        setImageMatriz,
        pdfMatriz,
        setPdfMatriz,
      }}
    >
      {children}
    </MatrizFileContext.Provider>
  );
};

export const useMatrizFileContext = (): MatrizFileContextType => {
  const context = useContext(MatrizFileContext);
  if (context === undefined) {
    throw new Error('useFileContext must be used within a FileProvider');
  }
  return context;
};
